import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Flex, Heading, Link, Text } from 'rebass';
import { getLogoSource } from '../scheduleDoctor/helpers/insuranceLogos';
import moment from 'moment';
import { GET_BRIDGE_CONSENTS_TO_AGREE } from '../../graphql';
import SpinLoader from '../../components/SpinLoader';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import ConfirmModal from '../../components/ConfirmModal';

const ModalInner = styled(Flex)`
  flex-direction: column;
  max-width: 600px;
  width: 100%;
`;
export const ConsentBox = ({ consent, onClick, isChecked }) => {
  const [label, setLabel] = useState();

  useEffect(
    () => {
      switch (consent.type) {
        case 'ASSIGNMENT_OF_BENEFITS':
          setLabel({
            text: 'Assignment of benefits',
            url: 'https://static.cloudhealthmedicalgroup.com/docs/Assignment%20of%20Benefits%20(MA)%20-%202025-06-05.pdf',
          });
          break;
        case 'CONSENT_TO_TREAT':
          setLabel({
            text: 'Consent to treat',
            url: 'https://static.cloudhealthmedicalgroup.com/docs/Consent+for+Healthcare+Services+-+2024-05-13.pdf',
          });
          break;
        case 'PRIVACY_NOTICE':
          setLabel({
            text: 'Privacy notice',
            url: 'https://bridge-static-files.s3.amazonaws.com/legal/Bridge_Privacy_Policy_2024-04-14.pdf',
          });
          break;

        default:
          break;
      }
    },
    [consent]
  );

  if (!label) return <div />;
  return (
    <Flex style={{ gap: '16px', alignItems: 'center' }}>
      <Flex style={{ border: '1px solid #344f79', width: 16, height: 16, background: isChecked ? '#344f79' : 'white' }} onClick={onClick}>
        <svg fillRule="evenodd" viewBox="0 0 12 9" style={{ display: isChecked ? 'initial' : 'none' }}>
          <path d="M4.1 6.1L1.4 3.4 0 4.9 4.1 9l7.6-7.6L10.3 0z" fill="white" />
        </svg>
      </Flex>
      <Link href={label.url} target="_blank">
        {label.text}
      </Link>
    </Flex>
  );
};
export const OnFileInsuranceBridge = ({
  insurance,
  useOnFileInsurance,
  wizard,
  session,
  InsuranceMemberChanged,
  insuranceMemberLost,
  revalidatePolicy,
  setConsents,
  deleteInsurance,
  upcomingAppointments,
}) => {
  const [consented, setConsented] = useState([]);
  const [mustAcceptTerms, setMustAcceptTerms] = useState(false);
  const [isConfirmDeletion, setIsConfirmDeletion] = useState(false);
  const [isCantDeleteWithAppointments, setIsCantDeleteWithAppointments] = useState(false);
  return (
    insurance &&
    insurance.payer && (
      <Query query={GET_BRIDGE_CONSENTS_TO_AGREE}>
        {({ loading, data: dataConsents }) => {
          // console.log(dataConsents);
          return (
            <>
              {!!loading ? (
                <SpinLoader />
              ) : (
                <Card p={4} mb={4}>
                  <Flex mb={4} flexDirection="column">
                    <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
                      <Flex flexDirection={'column'}>
                        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
                          <div>
                            <img src={getLogoSource(insurance.payer.name)} alt="" width="140px" />
                          </div>
                        </Flex>
                        {insurance.status === 'PENDING' ? (
                          <Text textAlign="center" mt={4}>
                            Your insurance information is under review by our team
                          </Text>
                        ) : (
                          <>
                            <Text fontWeight="600" textAlign="center" mt={4} fontSize="24px">
                              We Have an Insurance on File
                            </Text>
                            <Text textAlign="center" mt={3} fontSize="18px">
                              {`Member ID: ${insurance.memberId}`}
                            </Text>

                            {!!deleteInsurance && (
                              <Button
                                variant={'pink'}
                                onClick={() => {
                                  if (!!upcomingAppointments && upcomingAppointments.length > 0) {
                                    setIsCantDeleteWithAppointments(true);
                                    return;
                                  }
                                  setIsConfirmDeletion(true);
                                }}
                              >
                                Remove this insurance
                              </Button>
                            )}
                          </>
                        )}
                      </Flex>
                    </Flex>

                    {!!mustAcceptTerms && (
                      <ConfirmModal
                        isOpen={mustAcceptTerms}
                        onClose={() => setMustAcceptTerms(false)}
                        onBackgroundClick={() => setMustAcceptTerms(false)}
                        onConfirm={() => setMustAcceptTerms(false)}
                        childrenManaged
                      >
                        <ModalInner>
                          <Heading mb={3}>Patient Consents</Heading>
                          <Text mb={3} fontWeight={300}>{`Please review and accept those terms to continue:`}</Text>

                          <Flex style={{ gap: '12px', flexDirection: 'column', paddingLeft: '92px' }}>
                            {!!dataConsents &&
                              dataConsents.getBridgeConsentsToAgree &&
                              dataConsents.getBridgeConsentsToAgree.map((x) => {
                                return (
                                  <ConsentBox
                                    consent={x}
                                    onClick={(e) => {
                                      if (consented.findIndex((xx) => xx === x.id) > -1) {
                                        setConsented(consented.filter((xx) => xx.id !== x.id));
                                      } else {
                                        setConsented([...consented, x]);
                                      }
                                    }}
                                    isChecked={consented.findIndex((xx) => xx.id === x.id) > -1}
                                  />
                                );
                              })}
                          </Flex>

                          <Button
                            variant="primary"
                            mt={4}
                            disabled={
                              dataConsents && dataConsents.getBridgeConsentsToAgree && dataConsents.getBridgeConsentsToAgree.filter((x) => consented.findIndex((xx) => xx.id === x.id) < 0).length > 0
                            }
                            onClick={() => {
                              setConsents(consented);
                              // console.log({ insurance });
                              if (insurance.latest) {
                                const lastCheck = moment(insurance.latest.validatedAt).diff(moment(), 'day');
                                if (lastCheck > 14) {
                                  revalidatePolicy();
                                  return;
                                }
                              }
                              useOnFileInsurance(insurance, wizard);
                            }}
                          >
                            Continue
                          </Button>
                        </ModalInner>
                      </ConfirmModal>
                    )}

                    {!!isConfirmDeletion && (
                      <ConfirmModal
                        isOpen={isConfirmDeletion}
                        onClose={() => setIsConfirmDeletion(false)}
                        onBackgroundClick={() => setIsConfirmDeletion(false)}
                        onConfirm={() => setIsConfirmDeletion(false)}
                        childrenManaged
                      >
                        <ModalInner>
                          <Heading mb={3}>Confirm</Heading>
                          <Text mb={3} fontWeight={300}>{`Are you sure you want to delete your insurance?`}</Text>
                          <Flex mt={4} style={{ justifyContent: 'space-between' }}>
                            <Button
                              variant="primary"
                              onClick={() => {
                                setIsConfirmDeletion(false);
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="pink"
                              onClick={() => {
                                deleteInsurance();
                              }}
                            >
                              Yes
                            </Button>
                          </Flex>
                        </ModalInner>
                      </ConfirmModal>
                    )}

                    {!!isCantDeleteWithAppointments && (
                      <ConfirmModal
                        isOpen={isCantDeleteWithAppointments}
                        onClose={() => setIsCantDeleteWithAppointments(false)}
                        onBackgroundClick={() => setIsCantDeleteWithAppointments(false)}
                        onConfirm={() => setIsCantDeleteWithAppointments(false)}
                        childrenManaged
                      >
                        <ModalInner>
                          <Heading mb={3}>Unable to proceed</Heading>
                          <Text mb={3} fontWeight={300}>{`You can't remove your insurance while having booked appointments`}</Text>
                          <Text mb={3} fontWeight={300}>{`Cancel your appointments then retry`}</Text>
                          <Flex mt={4} style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Button
                              variant="outline"
                              onClick={() => {
                                setIsCantDeleteWithAppointments(false);
                              }}
                            >
                              OK
                            </Button>
                          </Flex>
                        </ModalInner>
                      </ConfirmModal>
                    )}
                  </Flex>
                </Card>
              )}
            </>
          );
        }}
      </Query>
    )
  );
};
